const KEY = 'missedCallCount';
const EVENT = 'missed-calls-changed';

function read(): number {
  try { return Math.max(0, parseInt(localStorage.getItem(KEY) || '0', 10) || 0); }
  catch { return 0; }
}
function write(n: number) {
  try { localStorage.setItem(KEY, String(Math.max(0, n))); } catch { /* noop */ }
  try { window.dispatchEvent(new Event(EVENT)); } catch { /* noop */ }
}

export function getMissedCount(): number { return read(); }
export function bumpMissed(): void { write(read() + 1); }
export function clearMissed(): void { write(0); }

/** Subscribe to missed-count changes (same-tab event + cross-tab storage). */
export function subscribeMissed(cb: () => void): () => void {
  const onStorage = (e: StorageEvent) => { if (e.key === KEY) cb(); };
  window.addEventListener(EVENT, cb);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener('storage', onStorage);
  };
}
